import { Card, StyledBody } from "baseui/card";
import { useMediaQuery } from "../../../hooks";
import { styled, useStyletron } from "baseui";


export const FlexGridCard = (props: { children: any, cardStyleOverride?: any, key?: any, small?: boolean }) => {
    const isSmallScreen = useMediaQuery('screen and (max-width: 600px)');
    const [css, theme] = useStyletron();
    const cardStyle = props.cardStyleOverride ?? defaultCardStyle;


    const smallStyle = props.cardStyleOverride ?? `1px solid ${theme.colors.borderOpaque}`;
    if (isSmallScreen || props.small) {
        return (<div className={css({ borderBottom: smallStyle, marginTop: theme.sizing.scale600, width: '100%' })}>
            {props.children}
        </div>)
    }
    return (
        <Card overrides={cardStyle} key={props.key || 1}>
            <StyledBody>
                {props.children}
            </StyledBody>
        </Card>)
}


const defaultCardStyle =
{
    Root: {
        style: ({ $theme }) => ({
            borderTopWidth: '1px',
            borderBottomWidth: '1px',
            borderLeftWidth: '1px',
            borderRightWidth: '1px',
            boxShadow: '0 1px 4px hsla(0, 0%, 0%, 0.05)'
        })
    }
};
